import AreaInput from "../../../../../components/AreaInput";
import {
  DESCRIPTION_INPUT_CLASS,
  FieldLabel,
  FormSection,
} from "../../../../../components/propertyDescription/descriptionUi";
import { PROPERTY_VALUES } from "../constants";
import PropertyValue from "../PropertyValue";

const CURRENCY_VALUES = PROPERTY_VALUES.filter(
  (item) => item.component === "currency"
);

type Props = {
  values: Record<string, number>;
  area: string;
  onChange: (field: string, value: unknown) => void;
};

export default function ValuesSection({ values, area, onChange }: Props) {
  return (
    <FormSection title="Valores">
      <div className="grid grid-cols-2 gap-x-4 gap-y-4 xl:grid-cols-4">
        {CURRENCY_VALUES.map((propertyValue) => (
          <PropertyValue
            key={propertyValue.attributeName}
            {...propertyValue}
            value={values[propertyValue.attributeName] ?? 0}
            onChange={(e) => onChange(propertyValue.attributeName, e)}
          />
        ))}
      </div>
      <div className="mt-4 max-w-xs">
        <FieldLabel>Área útil</FieldLabel>
        <AreaInput
          type="text"
          value={area}
          onChange={(event) => onChange("area", event.target.value)}
          className={DESCRIPTION_INPUT_CLASS}
        />
      </div>
    </FormSection>
  );
}
